import React from 'react';
import { ConfigProvider, Layout } from "antd";
import { Outlet } from "react-router-dom";
import './layout.css'
import Header from './header/header';
import { USER_ROLES, getCurrentUser } from '../services/User';
const { Content } = Layout;


function LayoutCountries() {
  const user = getCurrentUser();
  
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#006eb5'
        }
      }
      }
    >
      <Layout style={{ height: '100vh' }}>
        <Header />
        <Layout>
          <Content style={{overflow: 'auto', padding:32}}>
                <Outlet /> 
          </Content>
        </Layout>
      </Layout>
    </ConfigProvider>
  )
}

export default React.memo(LayoutCountries);